"use client";
import React, { useState } from "react";
import {
  isPossiblePhoneNumber,
  isValidPhoneNumber,
  validatePhoneNumberLength
} from 'libphonenumber-js'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import ru from 'react-phone-input-2/lang/ru.json'

import { FormData, RequestDetails as RequestDetailsType } from "./types";
import { RequestDetails } from "./RequestDetails";
import { NavigationButtons } from "./NavigationButtons";
import { Modal } from "./Modal";


interface UserDetailsStepProps {
  requestDetails: RequestDetailsType;
  formData: FormData;
  onFormDataChange: (field: keyof FormData, value: any) => void;
  onPrevStep: () => void;
  getTotalAmount: () => number;
  getTotalTip: () => string;
  
  onSubmit: (e:any) => void;
}

export const UserDetailsStep: React.FC<UserDetailsStepProps> = ({
  requestDetails,
  formData,
  onFormDataChange,
  onPrevStep,
  getTotalAmount,
  getTotalTip,
  onSubmit,
}) => {
  const [agreed, setAgreed] = useState(false);
  const [agreedPers, setAgreedPers] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [isValidPhone, setIsValidPhone] = useState(false);
  const [phoneChanged, setPhoneChanged] = useState(false);

  const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;  

  const isNextDisabled = () => {
    return !(formData.agreed && formData.agreedPers && formData.firstName && formData.lastName && isValidPhone && formData.email && formData.email.match(isValidEmail));
  };

  const isNextLoading = () => {
    return (formData.loading);
  };

  const handleChange =
    (field: keyof FormData) =>
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      if (e.target.type=='email'){
        if (!e.target.value.match(isValidEmail)) {
            e.target.setCustomValidity("Пожалуйста, введите корректный email адрес.");
        } else {
            e.target.setCustomValidity("");
        }
      }
      onFormDataChange(field, e.target.value);
    };

  const handlePhoneChange = (value: string,
      data: {} | any,
      e: React.ChangeEvent<HTMLInputElement>, formattedValue: string)  => {
    console.log('handlePhoneChange', formattedValue);
    setPhoneChanged(true);

    let isv = false;
    let inp = (document.getElementById('phone-input') as HTMLFormElement)
    if (!isValidPhoneNumber(formattedValue, data.countryCode.toUpperCase())) {
        console.log('formData.phone invalid', formattedValue);
        setIsValidPhone(false);
        inp.setCustomValidity("Пожалуйста, введите корректный номер телефона.");
        inp.reportValidity();
    } else {
        onFormDataChange('phone', formattedValue);
        setIsValidPhone(true);
        inp.setCustomValidity("");
        console.log('formData.phone is valid', formData.phone);
    }

  };

  const handleChangeChk =
    (field: keyof FormData) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onFormDataChange(field, e.target.checked);
    };

  const blurEmail = () =>
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      console.log('isValidEmail', e.target.value)
      if (!e.target.value.match(isValidEmail)) {
        console.log('setCustomValidity', e.target.value)
          e.target.setCustomValidity("Пожалуйста, введите корректный email адрес.");
      } else {
          e.target.setCustomValidity("");
      }
      e.target.reportValidity();
      return true;
  };

  const blurTel = () =>
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      if (e.target.type=='tel' && phoneChanged){
        if (!isValidPhone) {
          e.target.setCustomValidity("Пожалуйста, введите корректный номер телефона.");
          e.target.reportValidity();
        } else {
          e.target.setCustomValidity("");
        }
        setPhoneChanged(false)
      }
      return true;
  };

  const openModal =
    (mtype: string) => 
    (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      e.preventDefault();
      e.stopPropagation();
      setModalType(mtype);

      return setModalOpen(true);
    };

  return (
    <div>
      <RequestDetails details={requestDetails} totalAmount={getTotalAmount()} />

      <h2 className="mb-8 text-2xl font-light text-center uppercase">
        ВАШИ ДАННЫЕ
      </h2>

      <form
        className="flex flex-col gap-5 mx-auto my-0 w-full max-w-[800px] max-md:max-w-[600px] max-sm:px-2.5 max-sm:py-0 max-sm:max-w-full max-sm:min-w-[280px]"
        onSubmit={onSubmit}
      >
        <div className="flex gap-5 max-sm:flex-col">
          <input
            className="flex-1 p-3 text-sm border border-solid border-neutral-200"
            type="text"
            placeholder="Имя *"
            value={formData.firstName}
            required
            onChange={handleChange("firstName")}
          />
          <input
            className="flex-1 p-3 text-sm border border-solid border-neutral-200"
            type="text"
            placeholder="Фамилия *"
            value={formData.lastName}
            required
            onChange={handleChange("lastName")}
          />
        </div>
        <div className="flex gap-5 max-sm:flex-col">

          <div className="flex-1 text-sm basis-8">
            <PhoneInput
              country={'ru'}
              placeholder="Телефон *"
              value={formData.phone}
              preferredCountries={['ru']}
              priority={{ru:0,by:1,kz:2}}
              localization={ru}
              onBlur={blurTel()}
              onChange={handlePhoneChange}
              inputProps={{
                type: 'tel',
                name: 'phone',
                id: 'phone-input',
                className: "w-full p-3 pl-12 text-sm border border-solid border-neutral-200",
                required: true
              }}
            />
          </div>
          <input
            className="flex-1 p-3 basis-8 text-sm border border-solid border-neutral-200"
            type="email"
            placeholder="Email *"
            value={formData.email}
            required
            onBlur={blurEmail()}
            onChange={handleChange("email")}
          />
        </div>
        <textarea
          className="p-3 text-sm border border-solid resize-y border-neutral-200 min-h-[120px]"
          placeholder="Комментарий"
          value={formData.comment}
          onChange={handleChange("comment")}
        />
        <div className="grid grid-cols-2 grid-rows-2 max-sm:grid-cols-[1fr] max-sm:grid-rows-4 grid-flow-col p-3 gap-3">
            
            <label className="max-w-96 flex gap-2.5 items-center text-xs cursor-pointer m-3">
              <input
                type="checkbox"
                className="cursor-pointer"
                checked={formData.agreed}
                required
                onChange={handleChangeChk("agreed")}
              />
              <span>Я согласен с <a onClick={openModal("rules")} className="underline">правилами и условиями</a> *</span>
            </label>
            <label className="max-w-96 flex gap-2.5 items-center text-xs cursor-pointer m-3 ">
              <input
                type="checkbox"
                className="cursor-pointer"
                checked={formData.agreedPers}
                required
                onChange={handleChangeChk("agreedPers")}
              />
              <span>Даю согласие на <a onClick={openModal("policy")} className="underline">обработку персональных данных</a> *</span>
            </label>
            <input
              className="w-48 flex gap-2.5 m-3 p-1 text-sm border border-solid border-neutral-200"
              type="promo"
              placeholder="Промокод"
              value={formData.promo}
              onChange={handleChange("promo")}
            />
            <label className="max-w-96 flex gap-2.5 items-center text-xs cursor-pointer m-3">
              <input
                type="checkbox"
                className="cursor-pointer"
                checked={formData.isCompany}
                onChange={handleChangeChk("isCompany")}
              />
              <span>Бронирую от юр. лица</span>
            </label>


        </div>      

        <div className="flex gap-5 w-full justify-between max-sm:flex-col items-center pb-5">
            <button
            type="reset"
              className="flex gap-2 items-center px-5 py-4 text-xs bg-gray-200 cursor-pointer border-[none] text-[black] max-sm:justify-center max-sm:w-full"
              onClick={onPrevStep}
            >
              <div
                className="ml-2.5 w-2.5 h-2.5 border-l-2 border-b-2 border-solid transition-transform border-l-black border-b-black rotate-45"
              />
              <span className="text-black mr-2.5">НАЗАД</span>
            </button>
          <div  className="grow" />

            <div className="text-sm font-medium">
              <span>Итого: </span>
              <span className="text-amber-500">
                <span>{getTotalAmount()}</span>
                <span> ₽</span>
              </span>
            </div>

            <button
              type="submit"
              className="flex gap-2 items-center text-xs bg-black cursor-pointer border-[none] text-[white] max-sm:justify-center max-sm:w-full"
              onClick={e => onSubmit(e)}
              disabled={((isNextDisabled() || isNextLoading()))}
              style={{
                opacity: (isNextDisabled()) ? "0.5" : "1",
              }}
            >
              {(!isNextLoading() ||
                <>
                <div role="status" className="min-w-[165px] h-12 flex gap-2 items-center px-6 py-4 max-sm:justify-center max-sm:w-full">
                    <svg aria-hidden="true" className="w-5 h-5 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                    </svg>
                    <span className="text-white">БРОНИРУЕМ...</span>
                </div>
                
                </>
                )}
              {(isNextLoading() ||
                <div className="min-w-[165px] h-12 flex gap-2 items-center pl-10 max-sm:pl-0 py-4 max-sm:justify-center max-sm:w-full">
                  <span className="text-white">{"ОТПРАВИТЬ"}</span>
                  <div className="bg-amber-500 rounded h-[5px] w-[5px]" />
                </div>
                )}
            </button>
        </div>
      </form>
      <Modal isOpen={isModalOpen} modalType={modalType} onClose={() => setModalOpen(false)} />
      <ol className="list-decimal  list-inside font-extrabold font-bold font-normal font-light ps-2 ps-1 hidden"></ol>
    </div>
  );
};
